"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styles_1 = require("@material-ui/core/styles");
const Card_1 = __importDefault(require("@material-ui/core/Card"));
const CardActionArea_1 = __importDefault(require("@material-ui/core/CardActionArea"));
const CardActions_1 = __importDefault(require("@material-ui/core/CardActions"));
const CardContent_1 = __importDefault(require("@material-ui/core/CardContent"));
const CardMedia_1 = __importDefault(require("@material-ui/core/CardMedia"));
const Icon = __importStar(require("../Icons/Icon"));
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const core_1 = require("@material-ui/core");
const useStyles = styles_1.makeStyles(theme => ({
    root: {
        maxWidth: "240px",
        postition: "relative"
    },
    heading: {
        fontWeight: "bold",
        fontSize: "1.2em"
    },
    arrow: {
        height: "16px",
        width: "auto"
    },
    button: {
        color: theme && theme.palette.third ? theme.palette.third.main : null,
        fontWeight: "bold",
        marginRight: "10px",
        fontSize: "1.1em"
    },
    image: {
        margin: "10px",
        marginBottom: "-10px",
        width: "220px"
    },
    cardText: {
        height: "100%"
    },
    cardarea: {
        height: "100%"
    },
    cardactions: {
        position: "sticky",
        left: "0",
        bottom: "0"
    },
    banner: {
        backgroundColor: theme.palette.primary.dark,
        margin: "10px",
        fontSize: "16px",
        padding: "0.2rem",
        lineHeight: "24px",
        color: theme.palette.text.secondary,
        textAlign: "center",
        marginBottom: "0px"
    }
}));
function ImgMediaCard(props) {
    const classes = useStyles();
    return (react_1.default.createElement(Card_1.default, { style: props.style, className: `${classes.root} ${props.className}` },
        react_1.default.createElement(CardActionArea_1.default, { className: classes.cardarea },
            props.imageURL && typeof props.imageURL === 'string' ?
                react_1.default.createElement(CardMedia_1.default, { className: classes.image, component: "img", alt: "Contemplative Reptile", height: "140", image: props.imageURL, title: "Contemplative Reptile" })
                : "",
            props.header ?
                props.header
                : "",
            props.banner ?
                react_1.default.createElement("div", { className: classes.banner }, props.banner)
                : "",
            react_1.default.createElement(CardContent_1.default, { className: classes.cardText },
                react_1.default.createElement(Typography_1.default, { gutterBottom: true, className: classes.heading }, props.heading),
                react_1.default.createElement(Typography_1.default, { variant: "body2", color: "textPrimary", component: "p" }, props.content))),
        react_1.default.createElement(CardActions_1.default, { className: classes.cardactions },
            react_1.default.createElement(core_1.ButtonBase, { onClick: props.onClick, style: { marginLeft: "auto" } },
                react_1.default.createElement("p", { className: classes.button }, props.buttonText),
                react_1.default.createElement(Icon.ArrowRight, { className: classes.arrow })))));
}
exports.default = ImgMediaCard;
//# sourceMappingURL=Card.js.map